import { Component, Inject, OnInit } from '@angular/core';
import {
  CustomerService,
  WalletService,
  WalletStatusTypeEnum,
} from '@cai-services';
import { SessionService } from '../../../../core/_services/session.service';
import { APP_PROPS } from '../../../../cai-common.module';
import { ApplicationProperties } from '../../../../core/_base/layout/models/app-properties.model';

@Component({
  selector: 'kt-wallet-activation-thankyou',
  templateUrl: './wallet-activation-thankyou.component.html',
  styleUrls: ['./wallet-activation-thankyou.component.scss'],
  standalone: false,
})
export class WalletActivationThankyouComponent implements OnInit {
  constructor(
    @Inject(APP_PROPS)
    private readonly appProperties: ApplicationProperties,
    private readonly sessionService: SessionService,
    private readonly walletService: WalletService,
    private readonly customerService: CustomerService,
  ) {}

  async ngOnInit(): Promise<void> {
    const office = this.sessionService.getSelectedOffice(),
      officeId = office?.id?.toString(),
      walletStatus = this.sessionService.getSelectedOffice()?.id?.toString();
    if (officeId && walletStatus === WalletStatusTypeEnum.INACTIVE) {
      const updateStatusBody = {
        office_id: officeId,
        status: WalletStatusTypeEnum.PENDING,
      };
      if (this.isCargoWallet) {
        await this.customerService.updateWalletStatus(
          office.walletId,
          updateStatusBody,
        );
      } else {
        await this.walletService.updateWalletStatus(officeId, updateStatusBody);
      }
    }
  }

  get isCargoWallet(): boolean {
    return this.appProperties.name === 'cargowallet';
  }
}
